import {
  EDIT_SOFTSKILL_COURSE,
  EDIT_SOFTSKILL_COURSE_SUCCESS,
  EDIT_SOFTSKILL_COURSE_CLEAN,
  EDIT_SOFTSKILL_COURSE_ERROR,
} from "./actionTypes"

const initialState = {
  error: "",
  loading: false,
  done: false,
  course: undefined,
}

const SoftskillCourseEdit = (state = initialState, action) => {
  switch (action.type) {
    case EDIT_SOFTSKILL_COURSE:
      state = {
        ...state,
        loading: true,
      }
      break
    case EDIT_SOFTSKILL_COURSE_SUCCESS:
      state = {
        ...state,
        course: action.payload.course,
        loading: false,
        done: true,
      }
      break
    case EDIT_SOFTSKILL_COURSE_CLEAN:
      state = initialState
      break
    case EDIT_SOFTSKILL_COURSE_ERROR:
      state = { ...state, error: action.payload, loading: false, done: false }
      break
    default:
      state = { ...state }
      break
  }
  return state
}

export default SoftskillCourseEdit
